// extracted by mini-css-extract-plugin
export default {"login":"Login_login__qEDq3","input":"Login_input__rH+Qk","button":"Login_button__QO1G4"};